// import {
//   Card,
//   Collapse,
//   Drawer,
//   notification,
//   Table,
// } from 'antd'
// import React, {useEffect, useRef, useState} from 'react'
// import ReactHtmlParser from 'react-html-parser'
// import {connect, useDispatch} from 'react-redux'
// import PageHeaderWrapper from "../../components/PageHeaderWrapper";
// import {DisplayDate} from "../../components/_utils/appUtils";
// import {singleBlog} from "./actions";
//
// const {Panel} = Collapse
// const BlogDetailDrawer = props => {
//   let [articleData, setArticleData] = useState({})
//   const RowTable = props => {
//     let {title, value} = props
//     return (
//         <div className={'tableRow'}>
//           <div className={'title'}>{title}:</div>
//           <div>{value}</div>
//         </div>
//     )
//   }
//
//   const loadArticleData = async id => {
//     const {dispatch, form} = props
//     let {error, data} = await dispatch(singleBlog(props.blogId))
//     if (error) {
//       notification.error({
//         message: 'Error Loading Data'
//       })
//     } else {
//       console.log(data)
//       setArticleData(data)
//       console.log(articleData, 'shdhs')
//     }
//   }
//
//   let tableColumn = [
//     {
//       title: ' Image ',
//       name: 'image',
//       key: 'image',
//       dataIndex: 'image',
//       width: 400,
//       render: image => {
//         return <img src={image.path} style={{height: 120}}/>
//       }
//     }
//   ]
//
//   useEffect(
//       () => {
//         loadArticleData()
//         console.log(props)
//       },
//       [props.visible]
//   )
//
//   // const apiRequest = params => {
//   //   return new Promise(async resolve => {
//   //     let regExpFilters = ['keyword']
//   //     let result = await dispatch(
//   //       keywordList({ ...params, regExFilters: regExpFilters })
//   //     )
//   //     resolve(result)
//   //   })
//   // }
//
//   let authColumns = [
//     {
//       title: 'Sr.',
//       dataIndex: 'index',
//       key: 'index',
//       render: (item, record, key) => {
//         return key + 1
//       }
//     },
//     {
//       title: 'Name',
//       dataIndex: 'name',
//       key: 'name'
//     },
//     {
//       title: 'Email',
//       dataIndex: 'email',
//       key: 'email'
//     },
//     {
//       title: 'Super Script',
//       dataIndex: 'superScript',
//       key: 'superScript'
//     }
//   ]
//
//   return (
//       <>
//         <Drawer
//             visible={props.visible}
//             title='Blog Details'
//             onClose={props.onClose}
//             width='80%'>
//           <Card bordered={true}>
//             <PageHeaderWrapper>
//               <div className={'tableBox striped'}>
//                 <RowTable
//                     title={'Date'}
//                     value={
//                       articleData.createdAt
//                           ? DisplayDate(articleData.createdAt)
//                           : null
//                     }
//                 />
//                 <RowTable
//                     title={'Title'}
//                     value={
//                       articleData.title
//                           ? ReactHtmlParser(articleData.title)
//                           : null
//                     }
//                 />
//
//                 <div className={'tableRow'} style={{ display: 'none' }}></div>
//                 <RowTable
//                     title={'Keyword List'}
//                     value={
//                       articleData.blogKeywordList
//                           ? articleData.blogKeywordList.map((item, i) => {
//                             return (
//                                 <>
//                                   <div
//                                       key={i}
//                                       style={{
//                                         width: '100%'
//                                       }}>
//                                     {i + 1}. {item.keyword}
//                                   </div>
//                                 </>
//                             )
//                           })
//                           : null
//                     }
//                 />
//
//                 <RowTable
//                     title={'Meta Title'}
//                     value={
//                       articleData.metaTitle ? (
//                          ReactHtmlParser(articleData.metaTitle)
//                       ) : null
//                     }
//                 />
//                 <RowTable
//                     title={'Meta Description'}
//                     value={
//                       articleData.metaDescription ? (
//                          ReactHtmlParser(articleData.metaDescription)
//                       ) : null
//                     }
//                 />
//                 <RowTable
//                     title={'Meta Keywords'}
//                     value={
//                       articleData.metaKeywords ? (
//                          ReactHtmlParser(articleData.metaKeywords)
//                       ) : null
//                     }
//                 />
//                 <div className={'doi-form'}>
//
//                 <div className={'doi-form'}>
//
//                   <Card title='Description' className='p10'>
//                     {articleData.infoData
//                         ? articleData.infoData.map((item, i) => {
//                           return (
//                               <>
//                                 <div style={{marginTop: '8px'}}>
//                                   <Collapse>
//                                     <Panel
//                                         header={`${item.title} (${
//                                             item.menuHeading
//                                         })`}>
//                                       <p>{ReactHtmlParser(item.description)}</p>
//                                     </Panel>
//                                   </Collapse>
//                                 </div>
//                               </>
//                           )
//                         })
//                         : null}
//                   </Card>
//
//                   <Card title={'Images'}>
//                     {articleData.figure ? (
//                         <Table
//                             className='figureTable'
//                             bordered={true}
//                             dataSource={articleData.figure}
//                             columns={tableColumn}
//                             width={'100%'}
//                             pagination={false}
//                         />
//                     ) : null}
//                   </Card>
//                 </div>
//
//                 </div>
//               </div>
//             </PageHeaderWrapper>
//           </Card>
//         </Drawer>
//       </>
//   )
// }
// const mapStateToProps = ({global, router}) => ({
//   loading: global.buttonLoading,
//   categories: global.categories,
//   search: router.location.search,
//   pathname: router.location.pathname
// })
// const mapDispatchToProps = dispatch => {
//   return {
//     dispatch
//   }
// }
// // export default keyword;
// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(BlogDetailDrawer)





import {
  Card,
  Collapse,
  Drawer,
  notification,
  Table,
} from 'antd'
import React, {useEffect, useRef, useState} from 'react'
import ReactHtmlParser from 'react-html-parser'
import {connect, useDispatch} from 'react-redux'
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import {DisplayDate} from "../../components/_utils/appUtils";
import {singleBlog} from "./actions";

const {Panel} = Collapse
const BlogDetailDrawer = props => {
  let [articleData, setArticleData] = useState({})
  const RowTable = props => {
    let {title, value} = props
    return (
      <div className={'tableRow'}>
        <div className={'title'}>{title}:</div>
        <div>{value}</div>
      </div>
    )
  }

  const loadArticleData = async id => {
    const {dispatch, form} = props
    let {error, data} = await dispatch(singleBlog(props.blogId))
    if (error) {
      notification.error({
        message: 'Error Loading Data'
      })
    } else {
      console.log(data)
      setArticleData(data)
      console.log(articleData, 'shdhs')
    }
  }

  let tableColumn = [
    {
      title: ' Image ',
      name: 'image',
      key: 'image',
      dataIndex: 'image',
      width: 400,
      render: image => {
        return <img src={image.path} style={{height: 120}}/>
      }
    }
  ]

  // Columns for dynamic tables/supplementary tables matching the schema structure
  const subTableColumns = [
    {
      title: 'Image',
      dataIndex: 'image',
      key: 'image',
      render: image => (image && image.path) ? <img src={image.path} style={{height: 80}} /> : 'No Image'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: desc => desc ? ReactHtmlParser(desc) : '-'
    }
  ]

  // Columns for contributors table
  const contributorColumns = [
    { title: 'Name', dataIndex: 'fullName', key: 'fullName' },
    { title: 'Email', dataIndex: 'emailAddress', key: 'emailAddress' },
    { title: 'Designation', dataIndex: 'designation', key: 'designation' },
    { title: 'Institution', dataIndex: 'institution', key: 'institution' },
    { title: 'Country', dataIndex: 'country', key: 'country' },
    { title: 'Mobile', dataIndex: 'mobileNumber', key: 'mobileNumber' },
    { title: 'Biography', dataIndex: 'biography', key: 'biography' },
    { title: 'Role Description', dataIndex: 'roleDescription', key: 'roleDescription' }
  ]

  useEffect(
    () => {
      loadArticleData()
      console.log(props)
    },
    [props.visible]
  )

  // const apiRequest = params => {
  //   return new Promise(async resolve => {
  //     let regExpFilters = ['keyword']
  //     let result = await dispatch(
  //       keywordList({ ...params, regExFilters: regExpFilters })
  //     )
  //     resolve(result)
  //   })
  // }

  let authColumns = [
    {
      title: 'Sr.',
      dataIndex: 'index',
      key: 'index',
      render: (item, record, key) => {
        return key + 1
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Super Script',
      dataIndex: 'superScript',
      key: 'superScript'
    }
  ]

  return (
    <>
      <Drawer
        visible={props.visible}
        title='Blog Details'
        onClose={props.onClose}
        width='80%'>
        <Card bordered={true}>
          <PageHeaderWrapper>
            <div className={'tableBox striped'}>
              <RowTable
                title={'Date'}
                value={
                  articleData.createdAt
                    ? DisplayDate(articleData.createdAt)
                    : null
                }
              />
              <RowTable
                title={'Title'}
                value={
                  articleData.title
                    ? ReactHtmlParser(articleData.title)
                    : null
                }
              />

              {/* --- ADDED MISSING SCHEMA FIELDS BELOW (Existing code untouched) --- */}
              <RowTable
                title={'Slug URL'}
                value={articleData.slugUrl || null}
              />
              <RowTable
                title={'Secondary Category'}
                value={articleData.secondaryCategory || null}
              />
              <RowTable
                title={'Status'}
                value={articleData.status || null}
              />
              <RowTable
                title={'Total Views'}
                value={articleData.totalViews || 0}
              />
              <RowTable
                title={'Main Description'}
                value={
                  articleData.description
                    ? ReactHtmlParser(articleData.description)
                    : null
                }
              />
              <RowTable
                title={'References'}
                value={
                  articleData.references
                    ? ReactHtmlParser(articleData.references)
                    : null
                }
              />
              <RowTable
                title={'Featured Image'}
                value={
                  (articleData.featuredImage && articleData.featuredImage.path) ? (
                    <img src={articleData.featuredImage.path} style={{height: 100}} alt="Featured" />
                  ) : null
                }
              />
              <RowTable
                title={'Blog Document'}
                value={
                  (articleData.blogDocument && articleData.blogDocument.path) ? (
                    <a href={articleData.blogDocument.path} target="_blank" rel="noreferrer">
                      {articleData.blogDocument.fileName || 'Download Document'}
                    </a>
                  ) : null
                }
              />
              {/* --- END OF ADDED BASIC FIELDS --- */}

              <div className={'tableRow'} style={{ display: 'none' }}></div>
              <RowTable
                title={'Keyword List'}
                value={
                  articleData.blogKeywordList
                    ? articleData.blogKeywordList.map((item, i) => {
                      return (
                        <>
                          <div
                            key={i}
                            style={{
                              width: '100%'
                            }}>
                            {i + 1}. {item.keyword}
                          </div>
                        </>
                      )
                    })
                    : null
                }
              />

              <RowTable
                title={'Meta Title'}
                value={
                  articleData.metaTitle ? (
                    ReactHtmlParser(articleData.metaTitle)
                  ) : null
                }
              />
              <RowTable
                title={'Meta Description'}
                value={
                  articleData.metaDescription ? (
                    ReactHtmlParser(articleData.metaDescription)
                  ) : null
                }
              />
              <RowTable
                title={'Meta Keywords'}
                value={
                  articleData.metaKeywords ? (
                    ReactHtmlParser(articleData.metaKeywords)
                  ) : null
                }
              />
              <div className={'doi-form'}>

                <div className={'doi-form'}>

                  {/* --- ADDED CONTRIBUTORS, TABLES, SUPPLEMENTARY TABLES, & FAQS --- */}
                  {articleData.contributors && articleData.contributors.length > 0 && (
                    <Card title={'Contributors'} className='p10' style={{ marginBottom: 16 }}>
                      <Table
                        dataSource={articleData.contributors}
                        columns={contributorColumns}
                        rowKey={(record, index) => index}
                        pagination={false}
                        bordered={true}
                      />
                    </Card>
                  )}

                  {articleData.table && articleData.table.length > 0 && (
                    <Card title={'Tables'} className='p10' style={{ marginBottom: 16 }}>
                      <Table
                        dataSource={articleData.table}
                        columns={subTableColumns}
                        rowKey={(record, index) => index}
                        pagination={false}
                        bordered={true}
                      />
                    </Card>
                  )}

                  {articleData.supplementaryTable && articleData.supplementaryTable.length > 0 && (
                    <Card title={'Supplementary Tables'} className='p10' style={{ marginBottom: 16 }}>
                      <Table
                        dataSource={articleData.supplementaryTable}
                        columns={subTableColumns}
                        rowKey={(record, index) => index}
                        pagination={false}
                        bordered={true}
                      />
                    </Card>
                  )}

                  {articleData.faq && articleData.faq.length > 0 && (
                    <Card title={'FAQs'} className='p10' style={{ marginBottom: 16 }}>
                      {articleData.faq.map((item, i) => (
                        <div key={i} style={{ marginBottom: 8 }}>
                          <strong>Q: {item.question}</strong>
                          <p>A: {item.answer}</p>
                        </div>
                      ))}
                    </Card>
                  )}
                  {/* --- END OF ADDED SECTIONS --- */}

                  <Card title='Description' className='p10'>
                    {articleData.infoData
                      ? articleData.infoData.map((item, i) => {
                        return (
                          <>
                            <div style={{marginTop: '8px'}}>
                              <Collapse>
                                <Panel
                                  header={`${item.title} (${
                                    item.menuHeading
                                  })`}>
                                  <p>{ReactHtmlParser(item.description)}</p>
                                </Panel>
                              </Collapse>
                            </div>
                          </>
                        )
                      })
                      : null}
                  </Card>

                  <Card title={'Images'}>
                    {articleData.figure ? (
                      <Table
                        className='figureTable'
                        bordered={true}
                        dataSource={articleData.figure}
                        columns={tableColumn}
                        width={'100%'}
                        pagination={false}
                      />
                    ) : null}
                  </Card>
                </div>

              </div>
            </div>
          </PageHeaderWrapper>
        </Card>
      </Drawer>
    </>
  )
}
const mapStateToProps = ({global, router}) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
// export default keyword;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlogDetailDrawer)